import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  class: "jp-guide__mask",
  "aria-hidden": "true"
};
const _hoisted_3 = {
  key: 1,
  class: "jp-guide__shade jp-guide__shade--full"
};
const _hoisted_4 = {
  key: 0,
  class: "jp-guide__ribbon-wrap"
};
const _hoisted_5 = {
  class: "jp-guide__ribbon-title"
};
const _hoisted_6 = {
  key: 1,
  class: "jp-guide__body"
};
const _hoisted_7 = {
  class: "jp-guide__hint"
};
import { computed, nextTick, onUnmounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { DArrowRight } from '@element-plus/icons-vue';
import AppImage from '@/components/common/AppImage.vue';
import { Z_INDEX } from '@/config/zIndex';
import { getTrialFundAssets } from '@/constants/trial-fund';
import { useLayoutBreakpoint } from '@/composables/useLayoutBreakpoint';
import { lockBodyScroll, unlockBodyScroll, forceUnlockBodyScroll } from '@/composables/useBodyScrollLock';
import { useJackpotGuideStore } from '@/stores/jackpotGuide';
const HOLE_PAD = 6;
const BUBBLE_W = 280;
export default {
  __name: 'JackpotGuideHost',
  setup(__props) {
    const ANCHOR = {
      join: '[data-jackpot-guide="join"]',
      pick: '[data-jackpot-guide="pick"]',
      joinNow: '[data-jackpot-guide="join-now"]',
      pay: '[data-jackpot-guide="pay"]'
    };
    const STEP_ICON = {
      join: 'guideGift',
      pick: 'guideClock',
      joinNow: 'guideGift',
      pay: 'guideMoneybag'
    };
    const {
      t
    } = useI18n();
    const route = useRoute();
    const {
      isMobile
    } = useLayoutBreakpoint();
    const guide = useJackpotGuideStore();
    const {
      active,
      step,
      pickReady
    } = storeToRefs(guide);
    const guideZ = Z_INDEX.JACKPOT_GUIDE;
    const assets = getTrialFundAssets();
    const holeRect = ref(null);
    /** 确认支付步：整张底部弹窗，蒙层让开，点击仍只放行按钮 */
    const sheetRect = ref(null);
    /** 底栏「创建市场」凸起，单独盖一层，避免伸进高亮区 */
    const fabShade = ref(null);
    const handFloatPos = ref(null);
    const viewport = ref({
      w: 0,
      h: 0
    });
    let locked = false;
    let retryTimer = 0;
    let focusGen = 0;
    let pickAlignObserver = null;
    let pickAlignTimer = 0;
    let pickAlignCount = 0;
    /** 选号手指钉住的号码，避免每次测量换一个 */
    let fingerTicket = '';
    const stepIconSrc = computed(() => {
      const key = STEP_ICON[step.value];
      return key ? assets[key] || '' : '';
    });
    const ribbonBgStyle = computed(() => {
      if (!assets.guideRibbon) return {};
      return {
        backgroundImage: `url(${assets.guideRibbon})`
      };
    });
    const bubbleBgStyle = computed(() => {
      if (!assets.guideBannerBg) return {};
      return {
        backgroundImage: `url(${assets.guideBannerBg})`
      };
    });
    const bubbleBody = computed(() => {
      if (!step.value) return '';
      if (step.value === 'joinNow' || step.value === 'pick' && pickReady.value) {
        return t('jackpot.guide.steps.join');
      }
      return t(`jackpot.guide.steps.${step.value}`);
    });
    const handFloatStyle = computed(() => {
      const p = handFloatPos.value;
      if (!p || step.value !== 'pick' && step.value !== 'joinNow' || !assets.guideHand) return null;
      return {
        left: `${p.left}px`,
        top: `${p.top}px`
      };
    });
    const holeStyle = computed(() => {
      const r = holeRect.value;
      if (!r) return null;
      return {
        left: `${r.left}px`,
        top: `${r.top}px`,
        width: `${r.width}px`,
        height: `${r.height}px`
      };
    });
    const maskRect = computed(() => step.value === 'pay' && sheetRect.value ? sheetRect.value : holeRect.value);
    const shadeTop = computed(() => {
      const r = maskRect.value;
      if (!r) return null;
      return {
        left: '0',
        top: '0',
        right: '0',
        height: `${Math.max(0, r.top)}px`
      };
    });
    const shadeLeft = computed(() => {
      const r = maskRect.value;
      if (!r) return null;
      return {
        left: '0',
        top: `${Math.max(0, r.top)}px`,
        width: `${Math.max(0, r.left)}px`,
        height: `${r.height}px`
      };
    });
    const shadeRight = computed(() => {
      const r = maskRect.value;
      const vw = viewport.value.w || 0;
      if (!r) return null;
      const rightEdge = r.left + r.width;
      return {
        left: `${rightEdge}px`,
        top: `${Math.max(0, r.top)}px`,
        width: `${Math.max(0, vw - rightEdge)}px`,
        height: `${r.height}px`
      };
    });
    const shadeBottom = computed(() => {
      const r = maskRect.value;
      if (!r) return null;
      const top = r.top + r.height;
      return {
        left: '0',
        top: `${top}px`,
        right: '0',
        height: `calc(100vh - ${top}px)`
      };
    });
    const fabShadeStyle = computed(() => {
      const r = fabShade.value;
      if (!r) return null;
      return {
        left: `${r.left}px`,
        top: `${r.top}px`,
        width: `${r.width}px`,
        height: `${r.height}px`
      };
    });

    /** 弹窗内除确认按钮外的透明挡板，只拦截点击 */
    const payClickBlocks = computed(() => {
      if (step.value !== 'pay') return null;
      const sheet = sheetRect.value;
      const btn = holeRect.value;
      if (!sheet || !btn) return null;
      const btnBottom = btn.top + btn.height;
      const btnRight = btn.left + btn.width;
      const sheetRight = sheet.left + sheet.width;
      const sheetBottom = sheet.top + sheet.height;
      return {
        top: {
          left: `${sheet.left}px`,
          top: `${sheet.top}px`,
          width: `${sheet.width}px`,
          height: `${Math.max(0, btn.top - sheet.top)}px`
        },
        bottom: {
          left: `${sheet.left}px`,
          top: `${btnBottom}px`,
          width: `${sheet.width}px`,
          height: `${Math.max(0, sheetBottom - btnBottom)}px`
        },
        left: {
          left: `${sheet.left}px`,
          top: `${btn.top}px`,
          width: `${Math.max(0, btn.left - sheet.left)}px`,
          height: `${btn.height}px`
        },
        right: {
          left: `${btnRight}px`,
          top: `${btn.top}px`,
          width: `${Math.max(0, sheetRight - btnRight)}px`,
          height: `${btn.height}px`
        }
      };
    });
    const bubbleStyle = computed(() => {
      const vw = viewport.value.w || (typeof window !== 'undefined' ? window.innerWidth : 375);
      const vh = viewport.value.h || (typeof window !== 'undefined' ? window.innerHeight : 667);
      const width = Math.min(BUBBLE_W, vw - 32);
      const r = holeRect.value;
      let left = Math.max(16, (vw - width) / 2);
      let top = Math.max(vh * 0.28, 72);
      if (step.value === 'pay' && sheetRect.value) {
        const sheet = sheetRect.value;
        top = Math.max(16, sheet.top - 156);
        left = Math.max(16, (vw - width) / 2);
      } else if (r) {
        left = Math.min(Math.max(16, r.left + r.width / 2 - width / 2), vw - width - 16);
        const below = r.bottom + 12;
        const above = r.top - 168;
        if (below + 150 < vh - 16) top = below;else if (above > 56) top = above;else top = Math.max(56, Math.min(below, vh - 180));
      }
      return {
        width: `${width}px`,
        left: `${left}px`,
        top: `${top}px`
      };
    });
    function scrollPageToTop() {
      document.querySelectorAll('.jp-detail, .jp-lobby, .h5-jp-lobby').forEach(root => {
        let node = root;
        while (node && node !== document.documentElement) {
          node.scrollTop = 0;
          node = node.parentElement;
        }
      });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    }
    function releaseDockLift() {
      const dock = document.querySelector('.jp-cta-dock');
      if (!dock || dock.dataset.guideLift !== '1') return;
      dock.style.position = '';
      dock.style.left = '';
      dock.style.right = '';
      dock.style.width = '';
      dock.style.bottom = '';
      dock.style.zIndex = '';
      delete dock.dataset.guideLift;
    }

    /** 原底栏按钮不动逻辑，只在最后一步抬到引导蒙层上面，避免被挡住 */
    function liftDockAboveGuide() {
      const dock = document.querySelector('.jp-cta-dock');
      if (!dock) return;
      forceUnlockBodyScroll();
      locked = false;
      const rect = dock.getBoundingClientRect();
      const vh = window.innerHeight || 0;
      const inView = rect.width > 8 && rect.height > 8 && rect.top >= 0 && rect.bottom <= vh + 1;
      const tab = document.querySelector('.mobile-tab-bar');
      const tabH = tab ? Math.max(44, Math.ceil(tab.getBoundingClientRect().height)) : 56;
      dock.dataset.guideLift = '1';
      dock.style.zIndex = String(guideZ + 1);
      if (!inView) {
        dock.style.position = 'fixed';
        dock.style.left = '0';
        dock.style.right = '0';
        dock.style.width = '100%';
        dock.style.bottom = `${tabH + 3}px`;
      }
    }
    function enableLock() {
      if (locked) return;
      locked = true;
      lockBodyScroll();
    }
    function dockJoinVisible() {
      return Boolean(findJoinNowEl()?.closest('.jp-cta-dock'));
    }
    function lockUnlessDock() {
      if (dockJoinVisible()) return;
      enableLock();
    }
    function disableLock() {
      if (!locked) return;
      locked = false;
      unlockBodyScroll();
    }
    function clearRetry() {
      if (retryTimer) {
        window.clearTimeout(retryTimer);
        retryTimer = 0;
      }
    }
    function visibleGuideEl(el) {
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }

    /** 底部「立即参与」是 fixed 条，优先用它，不要对上隐藏的支付按钮 */
    function findJoinNowEl() {
      if (typeof document === 'undefined') return null;
      const nodes = Array.from(document.querySelectorAll('[data-jackpot-guide="join-now"]'));
      const dock = nodes.find(el => el.closest('.jp-cta-dock'));
      if (visibleGuideEl(dock)) return dock;
      return nodes.find(el => visibleGuideEl(el)) || null;
    }
    function findAnchor() {
      if (typeof document === 'undefined') return null;
      if (step.value === 'joinNow' || step.value === 'pick' && pickReady.value) {
        return findJoinNowEl();
      }
      if (step.value === 'pick') {
        const el = document.querySelector('[data-jackpot-guide="pick"] .jp-board__grid') || document.querySelector('[data-jackpot-guide="pick"]');
        return visibleGuideEl(el) ? el : null;
      }
      const sel = ANCHOR[step.value];
      if (!sel) return null;
      const list = Array.from(document.querySelectorAll(sel));
      return list.find(el => visibleGuideEl(el)) || null;
    }
    function listVisibleOpenCells() {
      const dock = document.querySelector('.jp-cta-dock');
      const limit = dock ? dock.getBoundingClientRect().top - 4 : window.innerHeight - 8;
      return Array.from(document.querySelectorAll('[data-jackpot-guide="pick"] .jp-board__cell.is-open')).filter(el => {
        const rect = el.getBoundingClientRect();
        return rect.width > 8 && rect.height > 8 && rect.top >= 4 && rect.bottom <= limit;
      });
    }
    function resolveFingerTarget() {
      if (typeof document === 'undefined') return null;
      if (step.value === 'joinNow' || step.value === 'pick' && pickReady.value) {
        return findJoinNowEl();
      }
      if (step.value !== 'pick') return null;
      const cells = listVisibleOpenCells();
      if (!cells.length) return null;
      const kept = fingerTicket ? cells.find(el => el.getAttribute('data-ticket') === fingerTicket) : null;
      const el = kept || cells[Math.floor(Math.random() * cells.length)];
      fingerTicket = el.getAttribute('data-ticket') || '';
      return el;
    }
    function measureHand() {
      const el = resolveFingerTarget();
      if (!el) {
        handFloatPos.value = null;
        return;
      }
      const rect = el.getBoundingClientRect();
      if (!(rect.width > 0 && rect.height > 0)) {
        handFloatPos.value = null;
        return;
      }
      // 指尖在图内约 30% 处，再叠加 translate(-18%, -18%)
      const hand = 72;
      const tip = hand * 0.3 - hand * 0.18;
      if (el.matches('[data-jackpot-guide="join-now"]')) {
        handFloatPos.value = {
          left: rect.left + rect.width * 0.8 - tip,
          top: rect.top + rect.height / 2 - tip
        };
        return;
      }
      handFloatPos.value = {
        left: rect.right - tip,
        top: rect.bottom - tip
      };
    }
    function readNavBottom() {
      const nav = document.querySelector('.app-nav');
      return nav ? nav.getBoundingClientRect().bottom : 0;
    }
    function pickVisibleBand() {
      const top = readNavBottom() + 8;
      const dock = document.querySelector('.jp-cta-dock');
      const bottom = dock ? dock.getBoundingClientRect().top - 4 : window.innerHeight - 8;
      return {
        top,
        bottom
      };
    }

    /** 盘面内滚动：把首个可买号滚进 surface 视口（展开虚拟列表时） */
    function scrollBoardSurfaceToOpen() {
      const section = document.querySelector('[data-jackpot-guide="pick"]');
      if (!section) return;
      const surface = section.querySelector('.jp-board__surface');
      const cell = section.querySelector('.jp-board__cell.is-open');
      if (!surface || !cell) return;
      const sRect = surface.getBoundingClientRect();
      const cRect = cell.getBoundingClientRect();
      if (!(sRect.height > 8) || surface.scrollHeight <= surface.clientHeight + 2) return;
      if (cRect.top >= sRect.top + 2 && cRect.bottom <= sRect.bottom - 2) return;
      const next = surface.scrollTop + (cRect.top - sRect.top) - Math.max(8, (sRect.height - cRect.height) / 3);
      surface.scrollTop = Math.max(0, next);
    }

    /**
     * 选号区对齐：优先让首个可买号落入导航与底栏之间的高亮带；
     * 没有可买号时退回「区块顶贴导航」。
     */
    function pickScrollDelta() {
      const section = document.querySelector('[data-jackpot-guide="pick"]');
      if (!section) return 0;
      const {
        top: bandTop,
        bottom: bandBottom
      } = pickVisibleBand();
      const cell = section.querySelector('.jp-board__cell.is-open');
      if (!cell) {
        return section.getBoundingClientRect().top - bandTop;
      }
      const grid = cell.closest('.jp-board__grid') || section.querySelector('.jp-board__grid') || cell;
      const target = grid.getBoundingClientRect();
      let delta = target.top - bandTop;
      const cellBottom = cell.getBoundingClientRect().bottom - delta;
      if (cellBottom > bandBottom) delta += cellBottom - bandBottom;
      const cellTop = cell.getBoundingClientRect().top - delta;
      if (cellTop < bandTop) delta -= bandTop - cellTop;
      return delta;
    }
    function applyScrollDelta(delta) {
      if (Math.abs(delta) < 2 || typeof window === 'undefined') return;
      const section = document.querySelector('[data-jackpot-guide="pick"]');
      const scroller = section ? pageScroller(section) : null;
      if (scroller) {
        scroller.scrollTop += delta;
        return;
      }
      const y = window.scrollY || document.scrollingElement?.scrollTop || 0;
      const next = Math.max(0, y + delta);
      window.scrollTo(0, next);
      if (document.scrollingElement) document.scrollingElement.scrollTop = next;
    }
    function pageScroller(el) {
      let node = el.parentElement;
      while (node && node !== document.body && node !== document.documentElement) {
        const oy = window.getComputedStyle(node).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && node.scrollHeight > node.clientHeight + 2) return node;
        node = node.parentElement;
      }
      return null;
    }

    /** 详情数据晚于路由到达，必须在选号区进 DOM 之后再滚；并保证高亮带内有可买号 */
    function alignPickSection() {
      const section = document.querySelector('[data-jackpot-guide="pick"]');
      if (!section || typeof window === 'undefined') return false;
      disableLock();
      section.style.scrollMarginTop = `${Math.ceil(readNavBottom() + 8)}px`;
      scrollBoardSurfaceToOpen();
      section.scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'auto'
      });
      applyScrollDelta(pickScrollDelta());
      scrollBoardSurfaceToOpen();
      const settled = Math.abs(pickScrollDelta()) < 8;
      const hasOpen = listVisibleOpenCells().length > 0;
      // 仍有可买号但高亮带里还没有：继续重试；盘面售罄则只要求位置稳定
      const anyOpen = Boolean(section.querySelector('.jp-board__cell.is-open'));
      return settled && (hasOpen || !anyOpen);
    }
    function stopPickAlignObserver() {
      if (pickAlignTimer) {
        window.clearTimeout(pickAlignTimer);
        pickAlignTimer = 0;
      }
      if (pickAlignObserver) {
        pickAlignObserver.disconnect();
        pickAlignObserver = null;
      }
    }

    /** 上方商品图撑开后只纠偏一次，避免和滚动锁来回抢位置 */
    function startPickAlignObserver(gen) {
      stopPickAlignObserver();
      pickAlignCount = 0;
      const root = document.querySelector('.jp-detail__main');
      if (!root || typeof ResizeObserver === 'undefined') return;
      pickAlignObserver = new ResizeObserver(() => {
        if (gen !== focusGen || step.value !== 'pick' || pickReady.value || pickAlignCount >= 3) {
          stopPickAlignObserver();
          return;
        }
        window.clearTimeout(pickAlignTimer);
        pickAlignTimer = window.setTimeout(() => {
          pickAlignTimer = 0;
          if (gen !== focusGen || step.value !== 'pick' || pickReady.value || pickAlignCount >= 3) {
            return;
          }
          const delta = pickScrollDelta();
          if (Math.abs(delta) < 4) return;
          pickAlignCount += 1;
          alignPickSection();
          lockUnlessDock();
          measure();
        }, 80);
      });
      pickAlignObserver.observe(root);
    }
    function measure() {
      if (typeof window === 'undefined') return;
      viewport.value = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      measureFabShade();
      const el = findAnchor();
      if (!el) {
        holeRect.value = null;
        measureSheet();
        measureHand();
        return;
      }
      const rect = el.getBoundingClientRect();
      const vw = viewport.value.w;
      const vh = viewport.value.h;
      let left = rect.left - HOLE_PAD;
      let top = rect.top - HOLE_PAD;
      let right = rect.right + HOLE_PAD;
      let bottom = rect.bottom + HOLE_PAD;
      if (step.value === 'pick' && !pickReady.value) {
        const dock = document.querySelector('.jp-cta-dock');
        if (dock) bottom = Math.min(bottom, dock.getBoundingClientRect().top - 4);
      }
      left = Math.max(4, left);
      top = Math.max(4, top);
      right = Math.min(vw - 4, right);
      bottom = Math.min(vh - 4, bottom);
      if (right - left < 8 || bottom - top < 8) {
        holeRect.value = null;
        measureSheet();
        measureHand();
        return;
      }
      holeRect.value = {
        left,
        top,
        width: right - left,
        height: bottom - top,
        bottom,
        right
      };
      measureSheet();
      measureHand();
    }
    function measureFabShade() {
      if (typeof document === 'undefined') {
        fabShade.value = null;
        return;
      }
      const fab = document.querySelector('.mobile-tab-bar__fab');
      if (!fab) {
        fabShade.value = null;
        return;
      }
      const rect = fab.getBoundingClientRect();
      if (!(rect.width > 0 && rect.height > 0)) {
        fabShade.value = null;
        return;
      }
      const pad = 8;
      fabShade.value = {
        left: rect.left - pad,
        top: rect.top - pad,
        width: rect.width + pad * 2,
        height: rect.height + pad * 2
      };
    }
    function measureSheet() {
      if (step.value !== 'pay' || typeof document === 'undefined') {
        sheetRect.value = null;
        return;
      }
      const sheet = document.querySelector('.jp-cta.is-h5-sheet');
      if (!sheet) {
        sheetRect.value = null;
        return;
      }
      const rect = sheet.getBoundingClientRect();
      if (!(rect.width > 0 && rect.height > 0)) {
        sheetRect.value = null;
        return;
      }
      sheetRect.value = {
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
        right: rect.right,
        bottom: rect.bottom
      };
    }
    async function focusStep() {
      const gen = ++focusGen;
      clearRetry();
      if (!active.value) {
        holeRect.value = null;
        sheetRect.value = null;
        fabShade.value = null;
        stopPickAlignObserver();
        disableLock();
        return;
      }
      if (step.value === 'join') {
        stopPickAlignObserver();
        fingerTicket = '';
        disableLock();
        await nextTick();
        if (gen !== focusGen) return;
        const el = findAnchor();
        if (el) el.scrollIntoView({
          block: 'center',
          inline: 'nearest',
          behavior: 'auto'
        });
      } else if (step.value === 'joinNow') {
        stopPickAlignObserver();
        fingerTicket = '';
        disableLock();
        await nextTick();
        if (gen !== focusGen) return;
        liftDockAboveGuide();
        const joinEl = findJoinNowEl();
        if (joinEl && !joinEl.closest('.jp-cta-dock')) {
          joinEl.scrollIntoView({
            block: 'center',
            inline: 'nearest',
            behavior: 'auto'
          });
        }
      } else if (step.value !== 'pick') {
        stopPickAlignObserver();
        releaseDockLift();
      } else {
        releaseDockLift();
      }
      if (gen !== focusGen) return;
      let tries = 0;
      const tick = () => {
        if (!active.value || gen !== focusGen) return;
        if (step.value === 'pick' && !pickReady.value) {
          const aligned = alignPickSection();
          measure();
          if (aligned && listVisibleOpenCells().length > 0) {
            lockUnlessDock();
            startPickAlignObserver(gen);
            return;
          }
          if (aligned) {
            // 售罄等无可买：仍锁定蒙层，避免一直空转
            const section = document.querySelector('[data-jackpot-guide="pick"]');
            if (!section?.querySelector('.jp-board__cell.is-open')) {
              lockUnlessDock();
              startPickAlignObserver(gen);
              return;
            }
          }
        } else {
          if (step.value === 'joinNow') liftDockAboveGuide();
          measure();
          if (holeRect.value) {
            lockUnlessDock();
            return;
          }
        }
        if (tries >= 40) {
          lockUnlessDock();
          measure();
          return;
        }
        tries += 1;
        retryTimer = window.setTimeout(tick, 100);
      };
      tick();
    }
    function onSkip() {
      guide.finish();
    }
    function syncRouteStep() {
      if (!guide.open) return;
      const name = route.name;
      const onJackpot = name === 'JackpotLobby' || name === 'JackpotDetail';
      if (!onJackpot) {
        guide.closeWithoutDone();
        return;
      }
      if (name === 'JackpotDetail' && guide.step === 'join') {
        guide.advanceFromJoin();
        return;
      }
      if (name === 'JackpotLobby' && (guide.step === 'pick' || guide.step === 'joinNow' || guide.step === 'pay')) {
        guide.rewindToJoin();
      }
    }
    watch(() => [active.value, step.value, pickReady.value, isMobile.value, route.name], () => {
      if (step.value !== 'pick') fingerTicket = '';
      syncRouteStep();
      void focusStep();
    });
    watch(active, on => {
      if (!on) {
        const backToTop = guide.done;
        clearRetry();
        stopPickAlignObserver();
        holeRect.value = null;
        sheetRect.value = null;
        fabShade.value = null;
        handFloatPos.value = null;
        fingerTicket = '';
        disableLock();
        releaseDockLift();
        if (backToTop) nextTick(scrollPageToTop);
      }
    });
    onUnmounted(() => {
      focusGen += 1;
      clearRetry();
      stopPickAlignObserver();
      disableLock();
      releaseDockLift();
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_unref(active) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "jp-guide",
        style: _normalizeStyle({
          zIndex: String(_unref(guideZ))
        }),
        role: "dialog",
        "aria-label": bubbleBody.value
      }, [_createElementVNode("div", _hoisted_2, [holeRect.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", {
        class: "jp-guide__shade",
        style: _normalizeStyle(shadeTop.value)
      }, null, 4), _createElementVNode("div", {
        class: "jp-guide__shade",
        style: _normalizeStyle(shadeLeft.value)
      }, null, 4), _createElementVNode("div", {
        class: "jp-guide__shade",
        style: _normalizeStyle(shadeRight.value)
      }, null, 4), _createElementVNode("div", {
        class: "jp-guide__shade",
        style: _normalizeStyle(shadeBottom.value)
      }, null, 4), _createElementVNode("div", {
        class: "jp-guide__ring",
        style: _normalizeStyle(holeStyle.value)
      }, null, 4), fabShadeStyle.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "jp-guide__shade jp-guide__shade--fab",
        style: _normalizeStyle(fabShadeStyle.value)
      }, null, 4)) : _createCommentVNode("", true), payClickBlocks.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", {
        class: "jp-guide__hit",
        style: _normalizeStyle(payClickBlocks.value.top)
      }, null, 4), _createElementVNode("div", {
        class: "jp-guide__hit",
        style: _normalizeStyle(payClickBlocks.value.left)
      }, null, 4), _createElementVNode("div", {
        class: "jp-guide__hit",
        style: _normalizeStyle(payClickBlocks.value.right)
      }, null, 4), _createElementVNode("div", {
        class: "jp-guide__hit",
        style: _normalizeStyle(payClickBlocks.value.bottom)
      }, null, 4)], 64)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_3))]), handFloatStyle.value ? (_openBlock(), _createBlock(AppImage, {
        key: 0,
        src: _unref(assets).guideHand,
        alt: "",
        class: "jp-guide__hand",
        style: _normalizeStyle(handFloatStyle.value),
        eager: ""
      }, null, 8, ["src", "style"])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "jp-guide__panel",
        style: _normalizeStyle(bubbleStyle.value)
      }, [_createElementVNode("div", {
        class: "jp-guide__bubble",
        style: _normalizeStyle(bubbleBgStyle.value)
      }, [stepIconSrc.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(AppImage, {
        src: stepIconSrc.value,
        alt: "",
        class: "jp-guide__step-icon",
        eager: ""
      }, null, 8, ["src"]), _createElementVNode("div", {
        class: "jp-guide__ribbon",
        style: _normalizeStyle(ribbonBgStyle.value)
      }, [_createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('jackpot.lobbyTitle')), 1)], 4)])) : _createCommentVNode("", true), bubbleBody.value ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(bubbleBody.value), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
        type: "button",
        class: "jp-guide__skip",
        onClick: _withModifiers(onSkip, ["stop"])
      }, [_createVNode(_component_el_icon, {
        size: 14,
        "aria-hidden": "true"
      }, {
        default: _withCtx(() => [_createVNode(_unref(DArrowRight))]),
        _: 1
      }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('jackpot.guide.skip')), 1)])], 4), _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('jackpot.guide.hint')), 1)], 4)], 12, _hoisted_1)) : _createCommentVNode("", true)]);
    };
  }
};